import { usePlatformData } from "../../hooks/usePlatformData";
import Dropdown from "../Dropdown";

interface DocumentPagesFilters {
  category: string | null;
}

export default function CategoryFilter({
  filters,
  handleCategoryChange,
}: {
  filters: DocumentPagesFilters;
  handleCategoryChange: (value: string) => void;
}) {
  const { categories } = usePlatformData();

  return (
    <>
      {/* Category Filter */}
      <div className="flex flex-col gap-2 justify-between">
        <label
          htmlFor="category"
          className="block text-sm font-medium text-gray-700 dark:text-zinc-100 mb-1"
        >
          Category
        </label>
        <Dropdown
          id="category"
          value={filters.category || ""}
          onChange={handleCategoryChange}
          disabled={categories.isLoading}
          placeholder="All Categories"
          options={[
            { label: "Uncategorized", value: "(null)" },
            { label: "Has category", value: "(not-null)" },
            ...(categories.data?.pageCategories.map((category) => ({
              label: category,
              value: category,
            })) ?? []),
          ]}
        />
        {categories.error && (
          <p className="mt-1 text-sm text-red-600">
            {categories.error.message}
          </p>
        )}
      </div>
    </>
  );
}
